import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const createSpinCampaignRoutes = {
  name: 'spin-campaign-create',
  path: 'spin-campaign/create',
  component: () => import('./CreateSpinCampaign.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
